import React from 'react';
import styled from 'styled-components';
import { Box, Text } from '@cubeyou-team/hx-react-components';

import translations from 'src/lang';

const lang = 'en-US';

const StyledRequiredText = styled.div`
  position: sticky;
  bottom: 0;
  padding: 1.25rem 0;
  background-color: #fff;
`;

export const RequiredText = () => {
  return (
    <StyledRequiredText>
      <Box>
        <Text size="small" variant="dark_lighter">
          {translations[lang].MODALS.REQUIRED_FILES}
        </Text>
      </Box>
    </StyledRequiredText>
  );
};
